// /#/auth-success?session=<hex>
// magic link verify 302 跳回的客户端落地页：抓 session、调 signInWithSession、跳 /rooms

import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { takePendingInvite } from "../lib/invite-api";
import { useAuth } from "../lib/use-auth";

export function AuthSuccessPage() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { signInWithSession } = useAuth();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const session = params.get("session");
    if (!session) {
      setError("缺少 session 参数");
      return;
    }
    signInWithSession(session)
      .then(() => {
        // pending invite 优先；否则跳 Room 列表
        const pending = takePendingInvite();
        const next = pending ? `/invite/${pending}` : "/rooms";
        setTimeout(() => nav(next, { replace: true }), 400);
      })
      .catch((e: Error) => {
        setError(e.message);
      });
  }, [params, signInWithSession, nav]);

  return (
    <section className="page page--login">
      {error ? (
        <>
          <h1>登录失败</h1>
          <p className="muted">{error}</p>
          <button className="btn" onClick={() => nav("/", { replace: true })}>
            返回登录
          </button>
        </>
      ) : (
        <>
          <h1>正在进入 ChatBox …</h1>
          <p className="muted">校验 session，马上就好。</p>
        </>
      )}
    </section>
  );
}
